import React, { useMemo } from 'react';

// DEPENDENCIES
import { useLocation } from 'react-router-dom';

// GLOBAL HELPERS
import { getRecordData } from 'helpers/getRecordData';
import useRecordView from 'helpers/getRecordView';

// GLOBAL COMPONENTS
import Page from 'parts/page/Page';

// MAIN COMPONENT
const RecordView = ({
  backPathname,
  ...props
}) => {

  // REACT ROUTER
  const { state } = useLocation();

  // CONTEXT
  const { rootPathname } = useRecordView();

  // MEMOS
  const backPathnameMemo = useMemo(
    () => {
      return state?.prevPath || backPathname || rootPathname;
    },
    [backPathname, state, rootPathname]
  );
  // RENDER
  return (
    <Page.View
      backPathname={backPathnameMemo}
      {...props}
    />
  );
};

// EXPORT
export default getRecordData(RecordView);
